import React from 'react';
import styled from 'styled-components';
import successIcon from 'images/mapClustoer/success_Icon.svg';

const Box = styled.div`
  position: relative;
  width: 343px;
  height: 68px;
  background: #f8f8f8;
  border-radius: 8px;
  margin: auto;

  & p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #212529;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }
`;

const ModalButton = styled.button`
  width: 164px;
  height: 48px;
  left: calc(50% - 164px / 2 - 89.5px);
  top: calc(50% - 48px / 2);
  background: #ffffff;
  border: 1px solid #ededf2;
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;
`;

const Contents = styled.div`
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  width: 100%;
  background: #fff;

  & .title {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
    color: #212529;
    padding-bottom: 24px;
  }

  & .paddingTop {
    padding-top: 24px;
  }

  & img {
    padding-bottom: 16px;
  }
`;

const Width = styled.div`
  width: 100%;
`;

const Send = ({ success, addressMap, selectedStores, onCancel, onConfirm }) => (
  <Contents>
    {success ? (
      <Width>
        <img src={successIcon} alt="" />
        <div className="title">제출완료</div>
        <Box style={{ height: '88px' }}>
          <p>
            제휴식당 선택제출이 완료되었습니다.
            <br />
            영업담당자가 결과를 확인중입니다.
          </p>
        </Box>
        <div className="paddingTop">
          <ModalButton onClick={onCancel} style={{ marginRight: '15px' }}>
            돌아가기
          </ModalButton>
        </div>
      </Width>
    ) : (
      <Width>
        <div className="title">정말로 제출하시겠습니까?</div>
        <Box>
          {selectedStores &&
            Object.entries(selectedStores).map(([key, value]) => (
              <p key={key}>
                {addressMap[key]}, {(value && value.length) || 0}개 선택 완료
              </p>
            ))}
        </Box>
        <div className="paddingTop">
          <ModalButton onClick={onCancel} style={{ marginRight: '15px' }}>
            돌아가기
          </ModalButton>
          <ModalButton onClick={onConfirm}>완료</ModalButton>
        </div>
      </Width>
    )}
  </Contents>
);

export default Send;
